import styled, { css, keyframes } from "styled-components";

import { stylesGlobalDefault } from "global/globalStyle";

import WifiIcon from "assets/svg/wifi.svg?react";

const blinkAnimation = keyframes`
  0%, 50% {
    opacity: 1;
  }
  50.01%, 100% {
    opacity: 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: calc(100vh - 60px);
  max-height: calc(100vh - 60px);
  background-color: #ecf0f3;
  display: flex;
  flex-direction: column;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${stylesGlobalDefault.blackMenu1};
  width: 100%;
  min-height: 80px;
`;

export const Title = styled.div`
  font-family: ${stylesGlobalDefault.fontFamily};
  font-weight: 700;
  font-size: 18px;
  color: ${stylesGlobalDefault.white};
  margin-left: 20px;
`;

export const BodyContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const PreviewContainer = styled.div`
  position: relative;
  max-height: calc(100vh - 220px);
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PreviewVideo = styled.video`
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const RecordingBadge = styled.div`
  min-width: 150px;
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 4px 8px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  color: ${stylesGlobalDefault.white};
  font-family: ${stylesGlobalDefault.fontFamily};
  font-size: 12px;
`;

export const RecordingDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ff0000;
  animation: ${blinkAnimation} 1s infinite;
`;

export const ConnectionBadge = styled(RecordingBadge)`
  top: 42px;
`;

export const ConnectionDot = styled(WifiIcon)`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  animation: ${blinkAnimation} 1s infinite;

  > g {
    fill: #ffb300;
  }
`;

export const RecordPauseButton = styled.div<{ disabled?: boolean }>`
  width: 48px;
  height: 48px;
  background: #eb5861;
  border-radius: 50%;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  transition: opacity 0.2s;

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        opacity: 0.8;
      }
    `}

  > svg,
  path {
    fill: white;
  }
`;

export const FinishButton = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;
  border: none;
  border-radius: 50px;
  outline: none;
  transition: all 0.2s;
  min-width: 188px;
  font-family: ${stylesGlobalDefault.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17.5px;
  height: 48px;
  transition: opacity 0.2s;

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        opacity: 0.8;
      }
    `}

  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  color: ${stylesGlobalDefault.white};
  background: ${stylesGlobalDefault.blue};

  > svg {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
`;

export const DeniedContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const FooterContainer = styled.div`
  width: 100%;
  min-height: 80px;
  background: ${stylesGlobalDefault.blackMenu1};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

